export default __webpack_public_path__ + "7050e4c472d9b83e76f29b5c2a65a42f.ttf";